export const getStyle = (isSmall, backgroundColor, desktopDirection) => {
  return `<style>
    :host {
      width:  ${isSmall ? '100%' : '90%'};
    }
    .main-wrapper {
      padding: 60px ${isSmall ? '12px' : '110px'};
      display: flex;
      flex-direction: ${isSmall ? 'column' : desktopDirection};
      align-items: center;
      justify-content: space-evenly;
      gap: 32px;
      background-color: ${backgroundColor};
    }
    video {
      width: ${isSmall ? '400px' : '600px'};
    }
    .text-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;
      text-align: center;
    }
    .title {
      font-size: ${isSmall ? '38px' : '50px'}
    }
    .full-width {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  </style>
`;
};
